module.exports = __webpack_public_path__ + "img/colour_select.3c2f87c5.png";